import { MutationOptions } from 'react-query';
import { offboardUser } from './users.api';
import { UserOffboardResponse } from './users.schema';

export const getOffboardUserMutation = (): MutationOptions<
  UserOffboardResponse,
  Error,
  number
> => ({
  mutationFn: (userId: number) => offboardUser(userId),
});
